<ng-container *ngIf="showAd">
  <ng-container *ngIf="format === 'auto'">
    <ins class="adsbygoogle"
         style="display:block"
         data-ad-client="{{adClient}}"
         data-ad-slot="{{slot}}"
         data-ad-format="auto"
         data-full-width-responsive="true">
    </ins>
  </ng-container>
  <ng-container *ngIf="format === 'fixed'">
    <ins class="adsbygoogle desktop"
         style="display:block;margin: 0 auto;width:728px;height:90px"
         data-ad-client="{{adClient}}"
         data-ad-slot="{{slot}}"
         data-full-width-responsive="true">
    </ins>
    <ins class="adsbygoogle mobile"
         style="display:block;width: 100%;max-width:320px;height:50px"
         data-ad-client="{{adClient}}"
         data-ad-slot="{{slot}}"
         data-full-width-responsive="true">
    </ins>
  </ng-container>
  <ng-container *ngIf="format === 'autorelaxed'">
    <ins class="adsbygoogle"
         style="display:block"
         data-ad-format="autorelaxed"
         data-ad-client="{{adClient}}"
         data-ad-slot="8872551766"></ins>
  </ng-container>
</ng-container>
